import type { QuoteStatus } from '../api/types';

export function StatusBadge({ status }: { status: QuoteStatus }) {
  return <span className={`status ${status}`}>{status}</span>;
}
